// extracted by mini-css-extract-plugin
module.exports = {"input":"_2v7AT7Li","label":"_2RVA0lsn _2EG4xZwe _26cqdtFW H6On8Sx7 qCnGG6r0 _1X0dhxAa","unselectedLabel":"_1ehARL1a","unselectedIcon":"_18pvIHzQ","selectedLabel":"_32iAdj1K"};